import { ModelType } from '@biteinc/enums';
import { dictionaryWordSchema } from '@biteinc/schemas';

app.DictionaryWord = app.AbstractModel.extend({
  ModelName: 'dictionaryWord',
  Schema: dictionaryWordSchema,
  Type: ModelType.DictionaryWord,
});
